import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'

interface CardTypeTooltipProps {
  className?: string
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
  onHover?: () => void
}

const CardTypeTooltip: React.FC<CardTypeTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip
      className={props.className}
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
      onHover={props.onHover}
    >
      <p>
        <Trns
          source={
            'Look for "corporate" or "business" on the front of your Amex card'
          }
        />
      </p>
    </Tooltip>
  )
}

export default CardTypeTooltip
